var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "td",
    {
      staticStyle: { padding: "0px" },
      attrs: { colspan: _vm.alternateStoreHeaders.length },
    },
    [
      _c(
        "v-container",
        { staticClass: "ma-0 pa-0", attrs: { fluid: "" } },
        [
          _c("v-data-table", {
            staticClass: "table",
            attrs: {
              headers: _vm.alternateStoreHeaders,
              items: _vm.alternateStoreItems,
              "hide-default-footer": "",
              dense: "",
              "fixed-header": "",
              "loader-height": "2",
            },
            scopedSlots: _vm._u(
              [
                _vm.tenant == "alliance-retail-group"
                  ? {
                      key: `item.is_shipper`,
                      fn: function ({ item }) {
                        return [
                          item.is_shipper
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: { icon: "", color: "primary" },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          _vm.selectedItem = item
                                          _vm.showComponents = true
                                        },
                                      },
                                    },
                                    [_c("v-icon", [_vm._v("mdi-view-list")])],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    }
                  : null,
                {
                  key: `item.promotion_price`,
                  fn: function ({ item, index }) {
                    return [
                      _c(
                        "td",
                        { staticClass: "px-2" },
                        [
                          _c(
                            "v-row",
                            { staticClass: "my-1 px-0" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 flex-grow-0",
                                  attrs: { cols: "3" },
                                },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      rules: _vm.multiplierRules,
                                      dense: "",
                                      outlined: "",
                                      "hide-details": "",
                                      solo: "",
                                      type: "number",
                                      disabled: "",
                                      value: item.multiplier,
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-icon",
                                { staticClass: "px-2", attrs: { size: "20" } },
                                [_vm._v("mdi-at")]
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0 flex-grow-1" },
                                [
                                  _c(
                                    "v-text-field",
                                    _vm._b(
                                      {
                                        staticClass: "px-0",
                                        attrs: {
                                          rules: _vm.srpRules,
                                          prefix: "$",
                                          dense: "",
                                          outlined: "",
                                          "hide-details": "",
                                          solo: "",
                                          step: ".01",
                                          type: "number",
                                          disabled: "",
                                        },
                                        model: {
                                          value: item.promotion_price,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              item,
                                              "promotion_price",
                                              _vm._n($$v)
                                            )
                                          },
                                          expression: "item.promotion_price",
                                        },
                                      },
                                      "v-text-field",
                                      {
                                        "data-row": index,
                                        "data-field": "srpInput",
                                      },
                                      false
                                    )
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0 flex-grow-0" },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      staticClass: "mt-5",
                                                      style: {
                                                        visibility:
                                                          item.linked_group !=
                                                          null
                                                            ? "visible"
                                                            : "hidden",
                                                      },
                                                      attrs: {
                                                        "x-small": "",
                                                        icon: "",
                                                        disabled: "",
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        attrs: {
                                                          color:
                                                            "blue darken-2",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-alpha-l-circle-outline"
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Apply SRP to ALL Linked Group items"
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { staticClass: "pa-0 flex-grow-0" },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    {
                                                      attrs: {
                                                        icon: "",
                                                        disabled: "",
                                                      },
                                                    },
                                                    on
                                                  ),
                                                  [
                                                    _c("v-icon", [
                                                      _vm._v(
                                                        "mdi-refresh-circle"
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [_c("span", [_vm._v("Reset Values")])]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: `item.group_manager_modified`,
                  fn: function ({ item, on }) {
                    return [
                      _c(
                        "v-simple-checkbox",
                        _vm._g(
                          {
                            attrs: {
                              value: item.group_manager_modified === true,
                              ripple: false,
                            },
                          },
                          on
                        )
                      ),
                    ]
                  },
                },
                {
                  key: `item.excluded`,
                  fn: function ({ item, on }) {
                    return [
                      _c(
                        "v-simple-checkbox",
                        _vm._g(
                          {
                            attrs: {
                              value:
                                item.excluded === "" || item.excluded === null,
                              ripple: false,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.toggleExcluded(item)
                              },
                            },
                          },
                          on
                        )
                      ),
                    ]
                  },
                },
                {
                  key: `item.rules_applied`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            top: "",
                            disabled: !_vm.hasRules(item.rules_applied),
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _vm.hasRules(item.rules_applied)
                                      ? _c(
                                          "v-icon",
                                          _vm._g(
                                            { attrs: { color: "success" } },
                                            on
                                          ),
                                          [_vm._v(" mdi-check-circle ")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _vm.hasRules(item.rules_applied)
                            ? _c(
                                "v-card",
                                { attrs: { width: "300" } },
                                [
                                  _c(
                                    "v-card-title",
                                    { staticClass: "text-subtitle-2" },
                                    [_vm._v("Applied Rules")]
                                  ),
                                  _c("v-divider"),
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    _vm._l(
                                      _vm.parseRules(item.rules_applied),
                                      function (rule, index) {
                                        return _c(
                                          "v-list-item",
                                          { key: index },
                                          [
                                            _c(
                                              "v-list-item-content",
                                              { staticClass: "pl-4" },
                                              [
                                                _c("v-list-item-title", [
                                                  _vm._v(
                                                    "Rule: " +
                                                      _vm._s(rule.display_name)
                                                  ),
                                                ]),
                                                _c("v-list-item-subtitle", [
                                                  _vm._v(
                                                    "Level: " +
                                                      _vm._s(
                                                        _vm.getRuleDisplay(
                                                          rule.level
                                                        )
                                                      )
                                                  ),
                                                ]),
                                                rule.priority != 52
                                                  ? _c("v-list-item-subtitle", [
                                                      _vm._v(
                                                        "Value: " +
                                                          _vm._s(
                                                            rule.displayValue
                                                          )
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: `item.enforce_compliance`,
                  fn: function ({ item }) {
                    return [
                      _c(
                        "v-tooltip",
                        {
                          attrs: {
                            disabled: !item.enforce_compliance,
                            top: "",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c(
                                      "v-icon",
                                      _vm._g(
                                        {
                                          attrs: {
                                            color: item.enforce_compliance
                                              ? "green"
                                              : "grey lighten-1",
                                          },
                                        },
                                        on
                                      ),
                                      [_vm._v(" mdi-shield-check-outline ")]
                                    ),
                                    _vm.tprProTenants && item.enforce_compliance
                                      ? _c(
                                          "v-icon",
                                          _vm._g(
                                            {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    !_vm.SRPIsCompliant(item),
                                                  expression:
                                                    "!SRPIsCompliant(item)",
                                                },
                                              ],
                                              attrs: {
                                                color:
                                                  _vm.getWarningColor(item),
                                              },
                                            },
                                            on
                                          ),
                                          [_vm._v(" mdi-exclamation-thick ")]
                                        )
                                      : _vm._e(),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                        },
                        [
                          _c("span", [_vm._v("Compliance Enforced")]),
                          _c("br"),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                "Variance: $" +
                                  parseFloat(item.variance).toFixed(2)
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
                {
                  key: `item.upc`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(_vm._s(item.upc > 2 ? item.upc : "")),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.cost`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          "$" + _vm._s(_vm.formatCurrencyDisplay(item.cost))
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.case_freight`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          "$" +
                            _vm._s(
                              item.case_freight
                                ? _vm.formatCurrencyDisplay(item.case_freight)
                                : _vm.formatCurrencyDisplay(item.cost)
                            )
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.amap_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          " $" +
                            _vm._s(
                              _vm.formatCurrencyDisplay(item.amap_allowance)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.dsd_oi_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          " $" +
                            _vm._s(
                              _vm.formatCurrencyDisplay(item.dsd_oi_allowance)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.early_buy_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          " $" +
                            _vm._s(
                              _vm.formatCurrencyDisplay(
                                item.early_buy_allowance
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.tpr_billback_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          " $" +
                            _vm._s(
                              _vm.formatCurrencyDisplay(
                                item.tpr_billback_allowance
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.tpr_scan_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          " $" +
                            _vm._s(
                              _vm.formatCurrencyDisplay(item.tpr_scan_allowance)
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.tpr_scan_epay_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-center",
                            staticStyle: { "white-space": "nowrap" },
                          },
                          [
                            item.tpr_scan_epay_allowance !== "N/A"
                              ? _c("span", [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.formatCurrencyDisplay(
                                          item.tpr_scan_epay_allowance
                                        )
                                      )
                                  ),
                                ])
                              : _c("span", [_vm._v("N/A")]),
                            item.tpr_scan_epay_allowance &&
                            item.tpr_scan_epay_allowance !== "N/A" &&
                            item.tpr_scan_epay_allowance > 0 &&
                            _vm.$auth.tenant === "alliance-retail-group"
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      color: "blue",
                                                      small: "",
                                                    },
                                                    on: {
                                                      mouseenter: function (
                                                        $event
                                                      ) {
                                                        return _vm.loadPromotionData(
                                                          item,
                                                          "tpr_scan_epay"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [_vm._v(" mdi-information ")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("TPR Scan ePay")]
                                      ),
                                      _c("br"),
                                      _vm.loadingPromoPrice &&
                                      _vm.selectedPromotionCategory ===
                                        "tpr_scan_epay" &&
                                      _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v("Loading promotion data..."),
                                          ])
                                        : _vm.promoPromotionPriceData &&
                                          _vm.promoPromotionPriceData
                                            .promotion_price &&
                                          _vm.selectedPromotionCategory ===
                                            "tpr_scan_epay" &&
                                          _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v(
                                              " Promotion Price: $" +
                                                _vm._s(
                                                  _vm.formatCurrencyDisplay(
                                                    _vm.promoPromotionPriceData
                                                      .promotion_price
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm.selectedPromotionCategory ===
                                            "tpr_scan_epay" &&
                                          _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v("No promotion price found"),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "Hover to load promotion data"
                                            ),
                                          ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.tpr_scan_compete_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-center",
                            staticStyle: { "white-space": "nowrap" },
                          },
                          [
                            item.tpr_scan_compete_allowance !== "N/A"
                              ? _c("span", [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.formatCurrencyDisplay(
                                          item.tpr_scan_compete_allowance
                                        )
                                      )
                                  ),
                                ])
                              : _c("span", [_vm._v("N/A")]),
                            item.tpr_scan_compete_allowance &&
                            item.tpr_scan_compete_allowance !== "N/A" &&
                            item.tpr_scan_compete_allowance > 0 &&
                            _vm.$auth.tenant === "alliance-retail-group"
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      color: "blue",
                                                      small: "",
                                                    },
                                                    on: {
                                                      mouseenter: function (
                                                        $event
                                                      ) {
                                                        return _vm.loadPromotionData(
                                                          item,
                                                          "tpr_scan_compete"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [_vm._v(" mdi-information ")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("TPR Scan Compete")]
                                      ),
                                      _c("br"),
                                      _vm.loadingPromoPrice &&
                                      _vm.selectedPromotionCategory ===
                                        "tpr_scan_compete" &&
                                      _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v("Loading promotion data..."),
                                          ])
                                        : _vm.promoPromotionPriceData &&
                                          _vm.promoPromotionPriceData
                                            .promotion_price &&
                                          _vm.selectedPromotionCategory ===
                                            "tpr_scan_compete" &&
                                          _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v(
                                              " Promotion Price: $" +
                                                _vm._s(
                                                  _vm.formatCurrencyDisplay(
                                                    _vm.promoPromotionPriceData
                                                      .promotion_price
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm.selectedPromotionCategory ===
                                            "tpr_scan_compete" &&
                                          _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v("No promotion price found"),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "Hover to load promotion data"
                                            ),
                                          ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.edlc_billback_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          " $" +
                            _vm._s(
                              _vm.formatCurrencyDisplay(
                                item.edlc_billback_allowance
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.edlc_scan_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          " $" +
                            _vm._s(
                              _vm.formatCurrencyDisplay(
                                item.edlc_scan_allowance
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.edlc_scan_epay_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-center",
                            staticStyle: { "white-space": "nowrap" },
                          },
                          [
                            item.edlc_scan_epay_allowance !== "N/A"
                              ? _c("span", [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.formatCurrencyDisplay(
                                          item.edlc_scan_epay_allowance
                                        )
                                      )
                                  ),
                                ])
                              : _c("span", [_vm._v("N/A")]),
                            item.edlc_scan_epay_allowance &&
                            item.edlc_scan_epay_allowance !== "N/A" &&
                            item.edlc_scan_epay_allowance > 0 &&
                            _vm.$auth.tenant === "alliance-retail-group"
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      color: "blue",
                                                      small: "",
                                                    },
                                                    on: {
                                                      mouseenter: function (
                                                        $event
                                                      ) {
                                                        return _vm.loadPromotionData(
                                                          item,
                                                          "edlc_scan_epay"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [_vm._v(" mdi-information ")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("EDLC Scan ePay")]
                                      ),
                                      _c("br"),
                                      _vm.loadingPromoPrice &&
                                      _vm.selectedPromotionCategory ===
                                        "edlc_scan_epay" &&
                                      _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v("Loading promotion data..."),
                                          ])
                                        : _vm.promoPromotionPriceData &&
                                          _vm.promoPromotionPriceData
                                            .promotion_price &&
                                          _vm.selectedPromotionCategory ===
                                            "edlc_scan_epay" &&
                                          _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v(
                                              " Promotion Price: $" +
                                                _vm._s(
                                                  _vm.formatCurrencyDisplay(
                                                    _vm.promoPromotionPriceData
                                                      .promotion_price
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm.selectedPromotionCategory ===
                                            "edlc_scan_epay" &&
                                          _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v("No promotion price found"),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "Hover to load promotion data"
                                            ),
                                          ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.edlc_scan_compete_allowance`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _c(
                          "div",
                          {
                            staticClass: "d-flex align-center",
                            staticStyle: { "white-space": "nowrap" },
                          },
                          [
                            item.edlc_scan_compete_allowance !== "N/A"
                              ? _c("span", [
                                  _vm._v(
                                    "$" +
                                      _vm._s(
                                        _vm.formatCurrencyDisplay(
                                          item.edlc_scan_compete_allowance
                                        )
                                      )
                                  ),
                                ])
                              : _c("span", [_vm._v("N/A")]),
                            item.edlc_scan_compete_allowance &&
                            item.edlc_scan_compete_allowance !== "N/A" &&
                            item.edlc_scan_compete_allowance > 0 &&
                            _vm.$auth.tenant === "alliance-retail-group"
                              ? _c(
                                  "v-tooltip",
                                  {
                                    attrs: { top: "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on }) {
                                            return [
                                              _c(
                                                "v-icon",
                                                _vm._g(
                                                  {
                                                    staticClass: "ml-1",
                                                    attrs: {
                                                      color: "blue",
                                                      small: "",
                                                    },
                                                    on: {
                                                      mouseenter: function (
                                                        $event
                                                      ) {
                                                        return _vm.loadPromotionData(
                                                          item,
                                                          "edlc_scan_compete"
                                                        )
                                                      },
                                                    },
                                                  },
                                                  on
                                                ),
                                                [_vm._v(" mdi-information ")]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c("div", [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("EDLC Scan Compete")]
                                      ),
                                      _c("br"),
                                      _vm.loadingPromoPrice &&
                                      _vm.selectedPromotionCategory ===
                                        "edlc_scan_compete" &&
                                      _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v("Loading promotion data..."),
                                          ])
                                        : _vm.promoPromotionPriceData &&
                                          _vm.promoPromotionPriceData
                                            .promotion_price &&
                                          _vm.selectedPromotionCategory ===
                                            "edlc_scan_compete" &&
                                          _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v(
                                              " Promotion Price: $" +
                                                _vm._s(
                                                  _vm.formatCurrencyDisplay(
                                                    _vm.promoPromotionPriceData
                                                      .promotion_price
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ])
                                        : _vm.selectedPromotionCategory ===
                                            "edlc_scan_compete" &&
                                          _vm.selectedPromotionItem === item
                                        ? _c("span", [
                                            _vm._v("No promotion price found"),
                                          ])
                                        : _c("span", [
                                            _vm._v(
                                              "Hover to load promotion data"
                                            ),
                                          ]),
                                    ]),
                                  ]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.unit_cost`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          "$" +
                            _vm._s(_vm.formatCurrencyDisplay(item.unit_cost))
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.net_unit_cost`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          "$" +
                            _vm._s(
                              _vm.formatCurrencyDisplay(item.net_unit_cost)
                            )
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.gross_profit`,
                  fn: function ({ item }) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            item.gross_profit != null
                              ? item.gross_profit.toFixed(2) + "%"
                              : ""
                          ) +
                          " "
                      ),
                    ]
                  },
                },
                {
                  key: `item.net_gross_profit`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          _vm._s(_vm._f("format")(item.net_gross_profit)) + "%"
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.retail_price`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(
                          "$" +
                            _vm._s(_vm.formatCurrencyDisplay(item.retail_price))
                        ),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.obxi`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(_vm._s(item.obxi)),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.like_code`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(_vm._s(item.like_code)),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.linked_group`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        item.linked_group && _vm.showLinkedGroupLink
                          ? _c(
                              "span",
                              {
                                staticClass:
                                  "primary--text cursor-pointer text-decoration-underline",
                                attrs: {
                                  title: `Filter by Linked Group: ${item.linked_group}`,
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.filterByLinkedGroup(
                                      item.linked_group
                                    )
                                  },
                                },
                              },
                              [_vm._v(" " + _vm._s(item.linked_group) + " ")]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(item.linked_group || "")),
                            ]),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.start_dt`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(_vm._s(_vm.formatDateDisplay(item.start_dt))),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.end_dt`,
                  fn: function ({ item }) {
                    return [
                      _c("td", { staticClass: "noWrap" }, [
                        _vm._v(_vm._s(_vm.formatDateDisplay(item.end_dt))),
                      ]),
                    ]
                  },
                },
                {
                  key: `item.rules_promotion_price`,
                  fn: function ({ item }) {
                    return [
                      item.rules_promotion_price
                        ? _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(
                                    item.rules_promotion_price
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
                {
                  key: `item.original_promotion_price`,
                  fn: function ({ item }) {
                    return [
                      item.original_promotion_price
                        ? _c("td", { staticClass: "noWrap" }, [
                            _vm._v(
                              " $" +
                                _vm._s(
                                  _vm.formatCurrencyDisplay(
                                    item.original_promotion_price
                                  )
                                ) +
                                " "
                            ),
                          ])
                        : _vm._e(),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }